import { useQuery } from '@tanstack/react-query';
import fetchWebApi from 'api/fetchWebApi';

type ClientPhone = {
  mobilePhone: string;
};

const useClientPhoneQuery = () => {
  return useQuery<ClientPhone>(
    ['client', 'phone'],
    async () => fetchWebApi('/client/phone'),
    {
      enabled: !!sessionStorage.getItem('token'),
    },
  );
};

export default useClientPhoneQuery;
